import React from "react";
import './App.css';
import {Product} from './Product';
import { AllProducts } from "./AllProducts";
import { Home } from "./Home";
import { HowToBuy } from "./HowToBuy";
import { CategoryProduct } from "./CategoryProduct";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SettingsProvider } from "./Context/SettingsContext";
import { Layout } from "./Layout";
import ReactPixel from 'react-facebook-pixel';
import { useEffect } from 'react';
import { useSettings } from "./Context/SettingsContext";

function PixelInitializer() {
  const settings = useSettings();
  
  useEffect(() => {
    if (settings?.PixelId) {
      ReactPixel.init(settings.PixelId);
    }
  }, [settings?.PixelId]);
  
  return null; // Este componente no renderiza nada
}

function App() {

  return (
    <SettingsProvider>
      <PixelInitializer />
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />          
            <Route path="/all" element={<AllProducts/>} />
            <Route path='/category/:categoryId' element={<CategoryProduct />} />
            <Route path='/product/:reference' element={<Product />} />
            <Route path="/howbuy" element={<HowToBuy />} />     
          </Route>
        </Routes>
      </Router>
    </SettingsProvider>
 
  );
}

export default App;
